// Module
var code = `<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="RegistrationForm" id="RegistrationForm" (submit)="submit()">
        <div class="HOA-misc-guidedSteps__container" >
            <div class="HOA-container__header">
                <div tid="addPropertyTitle" class="HOA-container__header-text">Add a Property</div>
                <pmc-logo *ngIf="property" class="u-right" property="property"></pmc-logo>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flextable-component__cell--mB30">
                    Enter Property IDs
                </div>
                <div class="HOA-container__content--borderNone">
                    <div class="HOA-flex-component HOA-flex-component--direction-column" [ngClass]="[uiSelectedViewName === uiViewName_BY_ADDRESS ? 'HOA-registration-isOption1' : 'HOA-registration-isOption2']">

                        <div class="HOA-registration-ifOption1-show1st HOA-registration-ifOption2-show3rd HOA-registration-ifOption2-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_ADDRESS"
                        >
                            <app-address-form
                                [property]="property"
                                (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                [showPropertyNickname]="true"
                                [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
                            </app-address-form>
                        </div>

                        <div class="HOA-registration-ifOption1-show3rd HOA-registration-ifOption2-show1st HOA-registration-ifOption1-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_IDS"
                        >
                            <div class="HOA-flex-component HOA-flex-component-sm-col-lg-row HOA-flextable-component__form">
                                <app-property-form-left [anonymous]="false" [disableInputsProperty]="disableInputsProperty"
                                                        [disablePropertyId]="disableInputsProperty" (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                                        class="HOA-flextable-component__form-vertical HOA-flextable-component__cell--alt50 HOA-flextable-component__form--left"
                                                        [property]="property" (blurFunction)="updateDefaultPropertyAddress()"></app-property-form-left>
                                <div class="HOA-guest-payment-padding-helper HOA-flextable-component__cell--alt50 HOA-flextable-component__form--right">
                                    <!-- This needs to stay so that the left stays correctly -->
                                </div>
                            </div>
                        </div>

                        <div class="HOA-registration-ifOption1-show3rd HOA-registration-ifOption2-show1st HOA-registration-ifOption1-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_ADDRESS"
                        >
                            <div id="unableToFindPropertyAnchor" class="u-pB8" *ngIf="!(disableInputsProperty) && searched && uiSelectedViewName === uiViewName_BY_ADDRESS">
                                <span>Please fill in your Property IDs below.</span>
                            </div>
                            <div class="HOA-flex-component HOA-flex-component-sm-col-lg-row HOA-flextable-component__form" >
                                <app-property-form-left id="propertyIdFormAnchor" [anonymous]="false" [disableInputsProperty]="disableInputsProperty" [disablePropertyId]="disableInputsProperty" (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                                        class="HOA-flextable-component__form-vertical HOA-flextable-component__cell--alt50 HOA-flextable-component__form--left" [property]="property"
                                                        (blurFunction)="updateDefaultPropertyAddress()">
                                </app-property-form-left>
                                <div class="HOA-guest-payment-padding-helper HOA-flextable-component__cell--alt50 HOA-flextable-component__form--right">
                                    <!-- This needs to stay so that the left stays correctly -->
                                </div>
                            </div>
                        </div>

                        <div class="HOA-registration-ifOption1-show1st HOA-registration-ifOption2-show3rd HOA-registration-ifOption2-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_IDS"
                        >
                            <div id="unableToFindAddressAnchor" class="u-pB8" *ngIf="!(disableInputsProperty) && searched && uiSelectedViewName === uiViewName_BY_IDS">
                                <span>Please fill in your address below.</span>
                            </div>
                            <!-- we need to be careful with dom order, this is a way to do so. -->
                            <app-address-form
                                id="addressFormAnchor"
                                [property]="property"
                                (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                [showPropertyNickname]="true"
                                [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
                            </app-address-form>
                        </div>
                    </div>
                    <div class="HOA-registration-button-container">
                        <button name="submit" id="submit" tid="submit" type="submit" class="Button Button--blue HOA-sm-order-1 HOA-lg-order-2"
                                [disabled]="!isCouponDataPresent() || !isAddressPresent() || managementIdError || associationIdError || invalidCheckVar">Register Property</button>
                        <button name="cancel" id="cancel" tid="cancel" type="button" class="Button Button--link HOA-sm-order-2 HOA-lg-order-1" (click)="cancel()">Cancel</button>
                    </div>
                </div>
                <div tid="requiredText" id="requiredText" class="u-pT2 HOA-flex-component HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;